<template>
  <div>
    <CCard class="sp_card">
      <!-- <CCardHeader class="sticky-top">
        <CRow>
          <CCol class="header-title">
            <span>リバティーリゾート会員アプリ</span>
            <h2>会員登録</h2>
          </CCol>
        </CRow>
      </CCardHeader> -->
      <!--m-0 mb-0 mt-5 -->
      <CCardBody class="p-4 card-body">
        <CForm class="home-form" v-if="topForm">
          <CAlert color="info">
            会員登録をお済でない方はこちらで会員登録をしてください。<br />
            すでに会員登録されている方は、アプリのトップ画面に戻り、ログインしてください。
          </CAlert>
          <!-- <h2 class="mb-2">会員登録</h2> -->
          <p class="mb-3">
            「<b class="text-danger">*</b>」がついた項目は必須項目となります。
          </p>

          <CInput
            class="required-mark"
            prepend="氏"
            v-model="itemToEdit.familyName"
          >
          </CInput>
          <span
            class="input-info"
            v-if="
              $v.itemToEdit.familyName.$dirty &&
              !$v.itemToEdit.familyName.required
            "
          >
            氏の入力は必須です
          </span>

          <CInput
            prepend="名"
            class="required-mark"
            v-model="itemToEdit.givenName"
          >
          </CInput>

          <span
            class="input-info"
            v-if="
              $v.itemToEdit.givenName.$dirty &&
              !$v.itemToEdit.givenName.required
            "
          >
            名の入力は必須です
          </span>

          <CInput placeholder="生年月日" v-model="itemToEdit.birth" type="date">
            <template #prepend-content>
              <!-- <CIcon name="cil-calendar" /> -->
              生年月日
            </template>
          </CInput>
          <CAlert color="warning" class="drop-buttons">
            <details class="d-md-none details_summary text-dark">
              <summary>iOS14の生年月日入力について(説明を表示)</summary>
              <ol>
                <li>生年月日をタップし、カレンダーを表示</li>
                <li>左上の年月(例:2020年11月)をタップ</li>
                <li>年月を選択する</li>
                <li>左上の年月をタップして日付選択に戻る</li>
                <li>日付を選択する</li>
                <li>OKをタップ</li>
              </ol>
            </details>
          </CAlert>
          <CInput
            class="required-mark"
            placeholder="電話番号"
            prepend="☏"
            type="number"
            v-model="itemToEdit.mobile"
          >
            <!-- ✆ -->
          </CInput>
          <div
            class="input-info"
            v-if="$v.itemToEdit.mobile.$dirty && !$v.itemToEdit.mobile.required"
          >
            電話番号の入力は必須です
          </div>
          <div class="input-info" v-if="!$v.itemToEdit.mobile.numeric">
            電話番号は数値を入力してください
          </div>
          <div class="input-info" v-if="!$v.itemToEdit.mobile.maxLength">
            電話番号は{{ limited.mobile.maxLength }}文字以下で入力してください
          </div>
          <div class="home-checkbok">
            <input
              type="checkbox"
              v-model="selectUser"
              @click="switchField()"
            />
            <label for="checkbox" class="text-dark"
              >メールアドレスをお持ちでない方</label
            >
          </div>
          <transition name="fade">
            <div v-if="!selectUser">
              <CInput
                class="required-mark"
                placeholder="Email"
                prepend="@"
                v-model="itemToEdit.email"
              />
              <span
                class="input-info"
                v-if="
                  $v.itemToEdit.email.$dirty && !$v.itemToEdit.email.required
                "
              >
                メールの入力は必須です
              </span>
              <span
                class="input-info text-danger"
                v-if="
                  $v.itemToEdit.email.$dirty &&
                  !$v.itemToEdit.email.alphaEmailValidator
                "
              >
                メールの形式が正しくありません。
              </span>
            </div>

            <div v-else>
              <div>
                <CInput
                  class="required-mark"
                  placeholder="Username"
                  v-model="itemToEdit.userName"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
              </div>
              <div class="text-warning input-info user-sms" v-if="selectUser">
                ▲ ログイン用のユーザー名、デフォルトは電話番号になります
              </div>
              <div
                class="input-info"
                v-if="
                  $v.itemToEdit.userName.$dirty &&
                  !$v.itemToEdit.userName.required
                "
              >
                ユーザー名の入力は必須です
              </div>
              <div
                class="input-info"
                v-if="
                  $v.itemToEdit.userName.$dirty &&
                  !$v.itemToEdit.userName.alphaNumValidator
                "
              >
                <span> 使用可能：英数字および記号(@+-_) <br /> </span>
              </div>
            </div>
          </transition>

          <CInput
            placeholder="パスワード"
            type="password"
            class="required-mark"
            v-model="itemToEdit.password"
          >
            <template #prepend-content>
              <CIcon name="cil-lock-locked" />
            </template>
          </CInput>
          <div
            class="input-info"
            v-if="
              $v.itemToEdit.password.$dirty && !$v.itemToEdit.password.required
            "
          >
            パスワードの入力は必須です
          </div>
          <div
            class="input-info"
            v-if="
              $v.itemToEdit.password.$dirty && !$v.itemToEdit.password.minLength
            "
          >
            パスワード制約：8文字以上
          </div>
          <div
            class="password-msg input-info"
            v-if="
              $v.itemToEdit.password.$dirty &&
              !$v.itemToEdit.password.alphaNumAndDotValidator
            "
          >
            <span> 使用可能：英数字および記号(!@#$%.?+-) <br /> </span>
          </div>

          <CInput
            placeholder="もう一度パスワードを入力してください"
            type="password"
            class="mb-4 required-mark"
            v-model="itemToEdit.repeatPassword"
          >
            <template #prepend-content>
              <CIcon name="cil-lock-locked" />
            </template>
          </CInput>

          <div
            class="input-info"
            v-if="
              $v.itemToEdit.repeatPassword.$dirty &&
              !$v.itemToEdit.repeatPassword.sameAsPassword
            "
          >
            もう一度パスワードを入力してください
          </div>
          <!-- <div class="password-msg input-info">
            <span>
              パスワード制約：8文字以上<br />
              使用可能：英数字および記号(!@#$%.?+-) <br />
              例：Kunozan@2020
            </span>
          </div> -->
          <CAlert color="warning">
            <span>
              パスワード制約：8文字以上<br />
              使用可能：英数字および記号(!@#$%.?+-) <br />
              例：Kunozan@2020
            </span>
          </CAlert>
          <!-- .check-terms  -->
          <CButton
            @click="$v.itemToEdit.$invalid ? requiredFd() : CheckForm()"
            color="success"
            size="lg"
            class="mt-5 p-center"
            block
            :class="$v.itemToEdit.$invalid ? 'inactive' : 'active'"
            >登録</CButton
          >
        </CForm>

        <div v-if="editingModal">
          <!-- <h2 class="mb-5">会員登録確認</h2> -->
          <div class="check_form">
            <CRow>
              <CCol sm="2" class="label">氏名</CCol>
              <CCol sm="4"
                >{{ itemToEdit.familyName }} {{ itemToEdit.givenName }}</CCol
              >
            </CRow>
            <CRow v-if="itemToEdit.birth">
              <CCol sm="2" class="label">生年月日</CCol>
              <!-- <CCol sm="4">{{ itemToEdit.birth }}</CCol> -->
              <CCol sm="4">{{ formatBirth() }}</CCol>
            </CRow>
            <CRow>
              <CCol sm="2" class="label">電話番号</CCol>
              <CCol sm="4">{{ itemToEdit.mobile }}</CCol>
            </CRow>
            <CRow v-if="!selectUser">
              <CCol sm="2" class="label">メール</CCol>
              <CCol sm="4">{{ itemToEdit.email }}</CCol>
            </CRow>
            <CRow v-else>
              <CCol sm="2" class="label">ユーザー名</CCol>
              <CCol sm="4">{{ itemToEdit.userName }}</CCol>
            </CRow>
            <CRow>
              <CCol sm="2" class="label">パスワード</CCol>
              <CCol sm="4">********</CCol>
            </CRow>
            <CRow>
              <CCol class="m-0 p-0">
                <div class="check_terms mt-2">
                  <PrivacyPolicy />
                  <div class="check-above">
                    <!-- <div class="home-checkbok">
                      <label >
                        <input type="checkbox" v-model="checkTerms" />
                        ご利用規約に同意する</label
                      >
                    </div> -->

                  <label class="check-inline">
                  <input
                    type="checkbox"
                    v-model="checkTerms"
                  />
                  <span>ご利用規約に同意する</span>
                </label>
                    <p>
                      入力内容のご確認および同意へのチェック後、「登録」ボタンを押下してください。<br />
                      【ご注意】no-reply@liberty-resort.net
                      からメールが届きますので、迷惑メールフィルタから除外してください。
                    </p>
                  </div>
                </div>
              </CCol>
            </CRow>
          </div>
          <CButton
            @click="
              editingModal = false;
              topForm = true;
            "
            size="lg"
            color="secondary"
            class="mb-4 float-left"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >

          <CButton
            @click="saveProfile()"
            size="lg"
            color="success"
            class="mb-4 float-right"
            :disabled="!checkTerms"
          >
            登録</CButton
          >
        </div>
        <!-- Edit modal section end  -->
        <div v-if="completedModal">
          <h4 class="mb-5">登録完了</h4>
          <CAlert color="success" class="mb-4">
            登録完了しました。<br />
            入力していただいたEメールアドレス宛に確認メールを送信しました。<br />
            迷惑メールの受信拒否設定により弊社からの返信が届かない場合があります。
          </CAlert>
          <CButton
            class="mt-4 p-center"
            onclick="window.location.reload();"
            color="success"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >
        </div>

        <div v-if="errorDialog">
          <CAlert color="danger">
            <h5>会員登録失敗</h5>
            {{ errors }}
          </CAlert>
          <CButton
            class="p-center"
            onclick="window.location.reload();"
            color="success"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >
        </div>
        <!-- complited modal end  -->
      </CCardBody>
      <!-- <CCardFooter class="fixed-bottom">
        Liberty Resort
      </CCardFooter> -->
    </CCard>
    <!-- dialog section ▌↓↓ -->
  </div>
</template>

<script>
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
const alphaEmailValidator = helpers.regex(
  "alphaEmail",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const alphaNumAndDotValidator = helpers.regex(
  "alphaNumAndDot",
  /^[A-Za-z0-9!@#$%.?+-]*$/
);
const alphaNumValidator = helpers.regex(
  "usernameValidator",
  /^[A-Za-z0-9@._-]*$/
);

export default {
  name: "AppRegistration",
  components: {},
  data() {
    return {
      topForm: true,
      confirmModal: false,
      editingModal: false,
      completedModal: false,
      errorDialog: false,
      selectUser: false,
      selectCard: false,
      checkTerms: false,
      allGroups: [],
      UserGroup: "",
      errors: "",
      itemToEdit: {
        email: "",
        familyName: "",
        givenName: "",
        birth: "",
        mobile: "",
        userName: "",
        password: "",
      },
      history: [],
      GUserId: "",
    };
  },
  validations() {
    let Gemail;
    let GuserName;
    if (!this.selectUser) {
      Gemail = { required, alphaEmailValidator };
      GuserName = { maxLength: maxLength(100), alphaNumValidator };
    } else {
      Gemail = { maxLength: maxLength(100) };
      GuserName = { required, alphaNumValidator };
    }
    return {
      itemToEdit: {
        familyName: { required, maxLength: maxLength(100) },
        // firstName: { required, maxLength: maxLength(100) },
        givenName: { required, maxLength: maxLength(100) },
        // lastName: { required, maxLength: maxLength(100) },
        // cardId: { numeric, minLength: minLength(16) },
        mobile: {
          required,
          numeric,
          maxLength: maxLength(20),
        },
        email: Gemail,
        userName: GuserName,
        password: {
          required,
          minLength: minLength(8),
          alphaNumAndDotValidator,
        },
        repeatPassword: {
          sameAsPassword: sameAs("password"),
        },
      },
    };
  },

  methods: {
    switchField() {
      this.itemToEdit.userName = this.itemToEdit.mobile;
      this.selectUser
        ? (this.itemToEdit.userName = "")
        : this.$delete(this.itemToEdit, "email");
    },

    saveProfile: function () {
      if (this.itemToEdit.email) {
        this.GUserId = this.itemToEdit.email;
      } else {
        this.GUserId = this.itemToEdit.userName;
      }

      this.$delete(this.itemToEdit, "repeatPassword");

      var urlRequest;
      urlRequest = "/api/users";
      console.log("editdata" + JSON.stringify(this.itemToEdit));
      axios
        .post(urlRequest, this.itemToEdit, {
          headers: { "api-token": "Eg=HyTs(;^5%Bv6y" },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.topForm = false;
          this.editingModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
          this.itemToEdit.password = "";
          this.errorDialog = true;
          this.topForm = false;
          this.editingModal = false;
          this.confirmModal = false;
          if (err.response.status == 409) {
            this.errors =
              "登録済みのメールアドレスです。別のメールアドレスを指定してください。";
          } else {
            this.errors = "会員登録できませんでした。";
          }
        });
    },
    CheckForm() {
      this.topForm = false;
      this.editingModal = true;
    },
    goEditPage() {
      this.$router.push({
        name: "会員情報編集",
        params: { userId: this.GUserId, success: true },
      });
    },
    requiredFd() {
      this.$v.itemToEdit.$touch();
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },

    onCheckResult() {
      return !this.$v.itemToEdit.$invalid;
    },

    formatBirth() {
      return this.itemToEdit.birth.replace(/-/g, "/");
    },
  },
  beforeMount() {},
};
</script>

<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-header {
    border: none;
    border-radius: 0;
    padding-top: 1%;
    padding-bottom: 1%;
    .header-title {
      text-align: center;

      span {
        font-size: 0.9rem;
        line-height: 0.9rem;
      }
      h2 {
        font-size: 1.4rem;
      }
    }

    color: #ffffff;
    background: #a17602;
  }
  .card-body {
    .alert {
      font-size: 0.85rem;
    }
    .drop-buttons {
      padding: 0 10px;
      summary {
        outline: none;
      }
    }
    .home-form {
      padding-bottom: 50px;

      .input-info {
        color: #222222;
      }
    }
  }
  .card-footer {
    border: none;
    border-top: 2px solid #a17602;
    padding: 1%;
    text-align: center;
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
.btn {
  width: 45%;
}
</style>

